export const getCartLineSellingPlans = lineItem =>
  (lineItem?.merchandise?.sellingPlanAllocations?.edges || []).map(({ node }) => node.sellingPlan);

export const getSellingPlanOptions = plans =>
  plans.map(({ id, name, options }) => ({
    value: id,
    text: options?.[0] ? `${options[0].name} ${options[0].value}` : name,
  }));
